import 'ui-theme/js/components/_drawer';
// file overridden for the neasted menu
const menu = UX.menu;

menu.on.showNested = function () {
    let nest_menu_opened = !menu.nestedMenu.next('.dropdown__menu').hasClass('sub-menu__opened');
    if (nest_menu_opened) {
        menu.on.listPosition.start('in');
    } else {
        menu.on.listPosition.start('out');
    }

    menu.nestedMenu.next('.dropdown__menu').toggleClass('sub-menu__opened');
    menu.nestedMenu.parent().toggleClass('menu-parent__opened');
    menu.nestedMenu.parent().siblings('li').removeClass('menu-parent__opened');
    menu.nestedMenu.parent().siblings('li').find('.dropdown__menu').removeClass('sub-menu__opened');
    menu.nestedMenu.find('i').toggleClass('opposite-arrow');
    menu.nestedMenu.parent().siblings('li').removeClass('prev-items');
    menu.nestedMenu.parent().siblings('li').addClass('prev-items');
    menu.nestedMenu.parent().removeClass('prev-items');
    $("[data-db-target-for='dbTab-collapsible-menu']").addClass('js--nested-open'); // replace Close button with back button after nested menu get opened
    const $menuTitle = menu.nestedMenu.find('span').html();
    const nestedMenuHeader = $('.secondary-menu-container [data-db-target-for="dbTab-collapsible-menu"] span');
    if (nestedMenuHeader) {
        nestedMenuHeader.html($menuTitle);
    } else {
        if ($('.menu-header').length) {
            $('.menu-header').html($menuTitle);
        }
    }
    menu.displayedNestedItems = true;

    menu.on.showNestedExtra();
};

menu.on.listPosition.scrollTo = function (menuElements, direction, value, timing = 0) {
    let secondary_menu = menuElements.sub.closest('.secondary-navigation').length > 0;
    let parentHeightVal =
            menu.listPositionVars.mainScrollingListHeight -
            (menuElements.parent.innerHeight() - menuElements.parent.height()), // height minus padding
        subHeightVal =
            menu.listPositionVars.mainScrollingListHeight -
            (menuElements.sub.innerHeight() - menuElements.sub.height()); // height minus padding
    if (direction === 'in') {
        if (secondary_menu) {
            menuElements.parent
                .find('.menu-parent .dropdown__menu')
                .css({height: 0, 'overflow-y': 'hidden', display: 'none'});

            menuElements.parent.attr('data-list-pos-corrected', 'true');
            menuElements.sub
                .css({height: 'fit-content', 'overflow-y': 'auto', display: 'block'})
                .attr('data-list-pos-corrected', 'true');
        } else {
            menuElements.parent
                .css({'max-height': parentHeightVal, height: parentHeightVal, 'overflow-y': 'hidden'})
                .attr('data-list-pos-corrected', 'true');
            menuElements.sub
                .css({'max-height': subHeightVal, height: subHeightVal, 'overflow-y': 'auto'})
                .attr('data-list-pos-corrected', 'true');
        }

        menuElements.parent.length &&
            menuElements.parent.animate(
                {
                    scrollTop: 0, // if we don't scroll the parent to the top, the sub will sometimes be cut off
                },
                {
                    duration: Math.abs(value - menuElements.parent.scrollTop()) > 125 ? 0 : timing,
                }
            );

        menuElements.sub.animate(
            {
                scrollTop: value,
            },
            {
                duration: Math.abs(value - menuElements.parent.scrollTop()) > 125 ? 0 : timing,
            }
        );
    } else if (direction === 'out') {
        if (secondary_menu) {
            menuElements.parent.attr('data-list-pos-corrected', 'true');
            menuElements.sub
                .css({'max-height': '', height: '', 'overflow-y': '', display: 'none'})
                .removeAttr('data-list-pos-corrected');
        } else {
            menuElements.parent.css({
                'max-height': parentHeightVal,
                height: parentHeightVal,
                'overflow-y': 'auto',
            });
            menuElements.sub
                .css({'max-height': '', height: '', 'overflow-y': ''})
                .removeAttr('data-list-pos-corrected');
        }

        menuElements.parent.length &&
            menuElements.parent.animate(
                {
                    scrollTop: value,
                },
                {
                    duration: Math.abs(value - menuElements.parent.scrollTop()) > 125 ? 0 : timing,
                }
            );
    }
};

menu.on.listPosition.handleHeightSet = function (e = {}, options = {}) {
    if (
        (menu.$toggle.hasClass('js--open') &&
            e.elapsedTime === menu.listPositionVars.bodyTransitionElapsedTime &&
            e.propertyName === menu.listPositionVars.bodyTransitionPropertyName) ||
        options.skipCheck === true
    ) {
        // not using $window.outerHeight() because it's return value doesn't change with the resize event
        menu.listPositionVars.mainScrollingListHeight =
            window.outerHeight - menu.listPositionVars.mainScrollingList[0].getBoundingClientRect().top;
        menu.listPositionVars.mainScrollingList
            .find('[data-list-pos-corrected="true"]')
            .add(menu.listPositionVars.mainScrollingList)
            .css({
                height: 'fit-content',
                'max-height': menu.listPositionVars.mainScrollingListHeight,
            });
    }
};
